import React from "react";
import DocMenus from "./DocMenus";
import DocSearchBlock from "./DocSearchBlock";
import '../../../assets/css/common/document/sidebar_list.scss';
import LoadMore from "../../../components/common/LoadMore/index";
import LoaderUI from "../../../components/common/loader/index";
import TotalCount from "../../../components/common/TotalCount";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faRedoAlt } from "@fortawesome/free-solid-svg-icons";

const SidebarList = ({ sortFn, page, list, handleSelectedAction, _filter, __filter, _resetFilter, search, handlePageChange, sidebarLoading, sidebarLoadingLabel, sidbarLoadingButton, _innerLodder, handleElasticSearch, elasticSearchList, focusSearchFlag, _focusSearch, filter, totalFolderRecords, _sidebarActivePacketIndex, sortBySelected, _sortBySelected, filterSelected, _filterSelected, myAssignedSelected, _myAssignedSelected, refreshFolders, folderRefreshFlag, hasNextPage, hasPrevPage, totalPages }) => {

	const _handleSelected = (id, docIndex) => {

		handleSelectedAction(id, docIndex);
	};
	const _search = (val, moreInfoObj) => {
		search(val, moreInfoObj);
	};
	const _handlePageChange = (activePage) => {
		handlePageChange(activePage);
	};

	const _refreshFolders = () => {
		refreshFolders();

	}

	return (
		<>
			<div className="sidebar-list d-flex flex-column flex-fill overflow-auto">
				<DocSearchBlock _resetFilter={_resetFilter} _handleSearch={(val, moreInfoObj) => _search(val, moreInfoObj)} _filterDocs={_filter} __filterDocs={__filter} __sortBySelected={_sortBySelected} sortBySelected={sortBySelected} filterSelected={filterSelected} __filterSelected={_filterSelected} myAssignedSelected={myAssignedSelected} __myAssignedSelected={(val) => { _myAssignedSelected(val) }} _handleElasticSearch={(val) => handleElasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} __focusSearch={(val => _focusSearch(val))} filter={filter} />
				<div className="refresh-list-hd d-flex align-items-center 111">
					{<TotalCount className="sidebarListBlc" name="Loan List" records={totalFolderRecords} />}
					<div className="rightCol ms-auto">
						{folderRefreshFlag &&
							<span data-toggle="tooltip" data-placement="top" title="New Folder" className="new-file-indicator">
								<img className="img-fluid" src={require('../../../assets/img/indicator.png')} alt="Indicator" />
							</span>
						}
						<Button color="link" data-toggle="tooltip" data-placement="top" title="Reload" onClick={_refreshFolders} className="refresh-btn d-inline-flex align-items-center justify-content-center">
							<FontAwesomeIcon icon={faRefresh} />
							{/* <span>Refresh</span> */}
						</Button>
					</div>

				</div>
				<div className="inner-blc  d-flex flex-column flex-fill overflow-auto position-relative">
					{!_innerLodder ? list?.length ?
						(<DocMenus list={list} sortFn={sortFn} _handleSelectedAction={(id, docIndex) => _handleSelected(id, docIndex)} __sidebarActivePacketIndex={_sidebarActivePacketIndex} />)
						: null : <LoaderUI FullWindow={false} inContainer={true} />}
				</div>
				<div className="pagin_cust">
					<div onClick={() => { _handlePageChange(page - 1) }} className={`prev ${!hasPrevPage ? "disabled" : ""}`}>
						<div>
							<i class='fas fa-angle-left'></i>
							Prev
						</div>
					</div>
					<div style={{ fontSize: "15px", paddingTop: "5px" }} className="page-no"> Page {page} / {totalPages}</div>
					{/* {sidbarLoadingButton && <LoadMore page={page} __handlePageChange={(activePage) => _handlePageChange(activePage)} loading={sidebarLoading} label={sidebarLoadingLabel} />} */}
					<div onClick={() => { _handlePageChange(page + 1) }} className={`next ${!hasNextPage ? "disabled" : ""}`}>
						<div>
							Next <i class='fas fa-angle-right'></i>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default SidebarList;
